<template>
  <div class="about-page">
    <v-row><h1 class="about-title mb-4">About</h1></v-row>
    <v-row>
      <v-col class="about-image-container">
        <!-- <img src="@/assets/AC moon.png" class="about-image"/> -->
      </v-col>
      <v-col class="about-summary">
        <p>
          I'm a software developer driven by a love for building. My focus is full-stack development, where I make complex tools feel effortless for users.
        </p>
        
        <p>
          Watching my work become something others enjoy and rely on fuels my creativity and sense of purpose.
        </p>

        <p>
          Outside the terminal, you'll find me lifting weights or exploring the wild frontier of spicy chicken sandwiches.
        </p>
        
        <p>
          Currently open to new opportunities and eager to collaborate on projects that make a real impact.
        </p>      
        <!-- <p class="pb-4">
          As an Application Developer, I built a Vue.js-powered ERP integration, enabling seamless scheduling and improving operational efficiency. 
          I also maintained SQL databases, ensuring robust data analysis and reporting. With experience training over 200 employees in software usage, I bring a strong emphasis on user-centric design and documentation, ensuring adoption at scale.
        </p>
        <p>
          Previously, as a Project Engineer, I developed cost optimization strategies, bid proposals, and HVAC system designs, demonstrating a detail-oriented approach to problem-solving and stakeholder management.
        </p> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
  data() {
    return {

    };
  },
  computed: {

  },
};
</script>

<style scoped>
.about-page {
  text-align: center;
  padding: 20px;
}
.about-summary, .about-image-container, .about-title {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  border: 3px solid #ddaf52;
}
.about-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 2.5vw;
  margin-right: 1.25vw;
  max-height: 60vh;
  height: fit-content;
  padding: 27px;        /* Optional: adjust based on spacing needs */
}
.about-title {
  font-size: clamp(5vh, 5.5vw, 6vh);
  margin-left: 2.5vw;
  text-align: left;
}
.skills-column {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.about-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: clamp(14px, 1.6vw, 20px);
  margin-left: 2.5vw;
  margin-right: 1.25vw;
  max-height: 60vh;
}
.about-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 10px; /* Optional: match the container's rounded corners */
}
</style>